import { render, staticRenderFns } from "./DashboardPanel.vue?vue&type=template&id=316b2316"
import script from "./DashboardPanel.vue?vue&type=script&lang=ts"
export * from "./DashboardPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports